export const VIDFLEET_CONFIGURATION_HUBSPOT_LOAD = "VIDFLEET_CONFIGURATION_HUBSPOT_LOAD";
export const VIDFLEET_CONFIGURATION_HUBSPOT_LOAD_RESULT = "VIDFLEET_CONFIGURATION_HUBSPOT_LOAD_RESULT";
export const VIDFLEET_CONFIGURATION_HUBSPOT_SAVE = "VIDFLEET_CONFIGURATION_HUBSPOT_SAVE";
export const VIDFLEET_CONFIGURATION_HUBSPOT_SAVE_RESULT = "VIDFLEET_CONFIGURATION_HUBSPOT_SAVE_RESULT";
export const VIDFLEET_CONFIGURATION_HUBSPOT_HIDE = "VIDFLEET_CONFIGURATION_HUBSPOT_HIDE";

